var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.504,
    height: 15.504,
    viewBox: "0 0 15.504 15.504",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4247",
    "data-name": "Group 4247",
    transform: "translate(-49 -1017.713)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5263",
    "data-name": "Path 5263",
    d: "M7.752,0A7.752,7.752,0,1,0,15.5,7.752,7.752,7.752,0,0,0,7.752,0Zm0,14.212a6.46,6.46,0,1,1,6.46-6.46A6.46,6.46,0,0,1,7.752,14.212Z",
    transform: "translate(49 1017.713)",
    fill: "#bbc6d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5264",
    "data-name": "Path 5264",
    d: "M11.326,5.044A2.821,2.821,0,0,0,8,7.82a.705.705,0,0,0,1.41,0,1.41,1.41,0,0,1,1.672-1.387A1.427,1.427,0,0,1,12.21,7.558a1.41,1.41,0,0,1-.705,1.5,2.788,2.788,0,0,0-1.39,2.471v.524a.705.705,0,1,0,1.41,0v-.524a1.4,1.4,0,0,1,.656-1.235,2.821,2.821,0,0,0-.855-5.248Z",
    transform: "translate(45.651 1015.397)",
    fill: "#bbc6d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2669",
    "data-name": "Rectangle 2669",
    width: 1.55,
    height: 1.55,
    rx: 0.775,
    transform: "translate(55.698 1029.27)",
    fill: "#bbc6d1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionCircle);
export default __webpack_public_path__ + "static/media/question-circle.b112355c906159bf09e6361935a0a09e.svg";
export { ForwardRef as ReactComponent };